import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Header from '../Header/Header';
import Navigation from '../Header/Navigation';
import NotificationIndex from './NotificationIndex';
import {
  NavOuter,
  NavContainer
} from '../Styles/index';

const linkItems = [
  {
    to: "/notifications",
    text: "Index",
    exact: true
  },
]; 

class Notifications extends Component {
  render() {
    return (
      <div>
        <Header/>
        <NavOuter bg={this.props.muiTheme.palette.primary2Color}>
          <NavContainer>
            <Navigation height={'36px'} darker items={linkItems}></Navigation>
          </NavContainer>
        </NavOuter>
        <Route exact path="/notifications" component={NotificationIndex}/>
      </div>
    );
  }
}



export default muiThemeable()(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notification/index.js